<script>
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import $ from "jquery";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";

export default {
  name: "OffersPage",
  components: {BottomNavigation, LoadingPage},
  setup() {

    let loading = ref(false)
    let offers = ref([])
    let dialog = ref({
      action: false,
      page: 'one',
    })

    let details_offer = ref({
      unit: null,
      offer_id: null,
      num: '',
      price: '',
    })

    function load_offers() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'shop/my_offers', true).then((res) => {

        loading.value = false
        offers.value = res.data

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_offers)
      })

    }
    load_offers()

    let select_offer
    function show_dialog(type , item) {

          if (!dialog.value.action) {
            dialog.value.page = type
              select_offer = item
            details_offer.value.unit = item.unit
            details_offer.value.offer_id = item.id
            $("#dialog_" + type).removeClass('animate__fadeOut').addClass('animate__fadeIn')
            dialog.value.action = true
          } else {
            $("#dialog_one").removeClass('animate__fadeIn').addClass('animate__fadeOut')
            $("#dialog_two").removeClass('animate__fadeIn').addClass('animate__fadeOut')
            setTimeout(() => {
              dialog.value.action = false
              details_offer.value = {
                unit: null,
                offer_id: null,
                num: '',
                price: '',
              }
            }, 700)
          }
    }

    function accept_offer(type) {

      if (type === 'one') {details_offer.value.num = select_offer.count ; details_offer.value.unit = select_offer.unit ; details_offer.value.price = select_offer.price; details_offer.value.offer_id = select_offer.id}

      if (details_offer.value.num.length === 0){Swals.Warning('لطفا حجم پیشنهادی خود را وارد کنید!');return false}
      if (details_offer.value.price.toString().length === 0){Swals.Warning('لطفا قیمت پیشنهادی خود را وارد کنید!');return false}
      if (details_offer.value.price.toString().startsWith('0')){Swals.Warning('لطفا قیمت پیشنهادی خود را به صورت صحیح وارد کنید!');return false}

      loading.value = true
      FreeWorld.Heisenberg(details_offer.value , 'shop/accept_offer' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          Swals.Done('پیشنهاد خرید شما با موفقیت ثبت شد')
        }else if(res.data.event === 'you have already accepted') {
          Swals.Fault('شما قبلا برای این پیشنهاد درخواست ارسال کرده اید!')
        }else {
          Swals.Fault('متاسفانه پیشنهاد خرید شما ثبت نشد!')
        }
        show_dialog()

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , ()=>{accept_offer(type)})
      })

    }


    const txtoverflow = document.querySelectorAll('.txtoverflow');

    function startAnimation() {
      txtoverflow.forEach(element => {
        element.classList.add('animate');
      });
    }

    function stopAnimation() {
      txtoverflow.forEach(element => {
        element.classList.remove('animate');
      });
    }

    txtoverflow.forEach(element => {
      element.addEventListener('animationstart', startAnimation);
      element.addEventListener('animationend', stopAnimation);
    });

    return {

      loading,
      offers,
      dialog,
      show_dialog,
      details_offer,
      accept_offer,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="dialog.action" @click="show_dialog" class="bg_dialog"></div>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">پیشنهاد خرید</p>
        <router-link :to="{name:'HomePage'}">
          <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="w-100 p-body ">

      <div v-if="offers.length === 0 && !loading" style="height: 45vh"
           class="d-flex justify-content-center align-items-end w-100 animate__animated animate__fadeIn">
        <div class="d-flex flex-column align-items-center justify-content-end">
          <img src="../assets/img/dont_offer.png" class="mb-5 w-35" alt="">
          <p class="font-4 font-bold">آیتمی برای نمایش وجود ندارد!</p>
        </div>
      </div>

      <div v-else class="">

        <div v-for="item in offers" :key="item.id" class="position-relative animate__animated animate__fadeInRight">

          <div class="overflow-hidden product text-decoration-none bg-white mb-2 shadow-custom p-2 rounded-4 position-relative">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex flex-column justify-content-around w-60">
                <div class="overflow-hidden">
                  <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
                </div>


                <div class="overflow-hidden">
                  <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 25}">از برند {{ item.brand }}</p>
                </div>

                <div class="d-flex align-items-end">
                  <img src="../assets/img/package2.png" class="icon-size-1">

                  <p style="white-space: nowrap" class="font-5 mx-1">حجم محصول :</p>

                  <div class="overflow-hidden">
                    <p :class="item.count.toString().length + item.unit.length > 10 ? 'txtoverflow':''"
                       class="font-5 font-color font-bold d-flex align-items-center">
                      <span class="mx-1">{{ item.count }} عدد</span>
                      <span class="">{{ item.unit }}</span>
                    </p>
                  </div>
                </div>

                <div class="d-flex align-items-end my-2">
                  <img src="../assets/img/credit2.png" class="icon-size-1">

                  <p class="font-5 mr-1">قیمت محصول :</p>

                  <p class="mx-1 font-color font-bold d-flex align-items-end">
                    <span class="font-5">{{ item.price.toLocaleString() }}</span>
                    <span class="font-6 mr-1">تومان</span>
                  </p>
                </div>

                <div class="d-flex align-items-end">
                  <img src="../assets/img/place_black.svg" class="icon-size-1">

                  <p class="font-5 mr-1">اطلاعات مقصد :</p>

                  <p class="mx-1 font-color font-bold font-5 d-flex align-items-end">{{ item.info }}</p>
                </div>

                <div class="div_hr my-2"></div>
              </div>

              <div class="img_prod rounded-3 animated-background">
                <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
              </div>

            </div>

            <div class="d-flex align-items-center justify-content-between">

              <div class="text-decoration-none text-black d-flex align-items-center">
                <img class="icon-size-0-5" src="../assets/img/user_color.svg" alt="">

                <div class="overflow-hidden d-flex align-items-center mx-1">
                <p class="font-4" :class="item.username.length > 13 ? 'txtoverflow':''">{{ item.username }}</p>
                </div>
              </div>

              <div class="d-flex align-items-center">
                <v-btn @click="show_dialog('one' , item)" class="text-decoration-none h-100 text-black bg-green py-1 px-2 font-6 rounded-pill shadow-custom">قبول پیشنهاد</v-btn>

                <v-btn @click="show_dialog('two' , item)" class="text-decoration-none h-100 mr-2 text-black bg-yellow py-1 px-2 font-6 rounded-pill shadow-custom">ثبت پیشنهاد جدید</v-btn>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>


    <div v-if="dialog.action && dialog.page === 'one'" id="dialog_one" class="dialog animate__animated animate__fadeIn max_width p-body">
      <div class="bg-white rounded-4">

        <div style="height: 45px"
             class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
          <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
               src="../assets/img/icon_dialog_offers.svg" alt="">
          <p class="text-white font-4">تایید پیشنهاد</p>
        </div>

        <div class="p-3">
          <div class="d-flex justify-content-center align-items-center mb-4-5 mt-5">
            <p class="font-4">آیا از قبول این پیشنهاد خرید اطمینان دارید؟</p>
          </div>

          <div class="d-flex align-items-center justify-space-between">
            <v-btn @click="accept_offer('one')" class="w-45 h-100 p-3 rounded-3 bg-green text-white text-center">بله</v-btn>

            <v-btn @click="show_dialog" class="w-45 h-100 p-3 rounded-3 bg-red text-white text-center">خیر</v-btn>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialog.action && dialog.page === 'two'" id="dialog_two" class="animate__animated animate__fadeIn dialog max_width p-body">
      <div class="bg-white rounded-4">

        <div style="height: 45px"
             class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
          <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
               src="../assets/img/icon_dialog_offers.svg" alt="">
          <p class="text-white font-4">تایید پیشنهاد</p>
        </div>

        <div class="p-3">
          <p class="font-5 text-center mb-3">مقادیر جدید را در ارتباط با این پیشنهاد وارد کنید</p>

          <div class="mb-3">
            <p class="font-4 font-bold font-color mb-2">واحد محصول</p>

            <div class="shadow-custom p-3 text-center font-4 rounded-4 w-100">{{ details_offer.unit }}</div>
          </div>

          <div class="mb-3">
            <p class="font-4 font-bold font-color mb-2">حجم محصول</p>

            <input v-model="details_offer.num" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" placeholder="مثلا 10" type="text">
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <p class="font-4 font-bold font-color mb-2">قیمت محصول</p>

              <p v-if="details_offer.price.length > 0" class="font-4 font-color-green font-bold">
                <span class="">{{ parseInt(details_offer.price).toLocaleString() }}</span>
                <span class="mr-1">تومان</span>
              </p>
            </div>

            <input v-model="details_offer.price" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" placeholder="تومان"
                   onkeydown="return event.key !== ' '" type="tel">
          </div>

          <div class="d-flex justify-content-center align-items-center">
            <v-btn @click="accept_offer" class="w-100 h-100 bg-color rounded-4 shadow-custom text-white p-3 font-4">ثبت نهایی</v-btn>
          </div>

        </div>
      </div>
    </div>

<BottomNavigation></BottomNavigation>

  </div>

</template>


<style scoped>
@media (min-width: 800px) and (max-width: 999px) {
  .img_prod{
    width: 30% !important;
    height: 11rem !important;
  }
}

@media (min-width: 1000px) {
  .img_prod{
    width: 25% !important;
    height: 13rem !important;
  }
}

.img_prod {
  width: 35%;
  height: 10rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

</style>